import { apiClient } from './api';

const employeeAPI = {
  // Get all employees with filters and pagination
  getEmployees: (params = {}) => {
    return apiClient.get('/employees', { params });
  },

  // Get single employee by ID
  getEmployee: (id) => {
    return apiClient.get(`/employees/${id}`);
  },

  // Create new employee
  createEmployee: (data) => {
    return apiClient.post('/employees', data);
  },

  // Update employee
  updateEmployee: (id, data) => {
    return apiClient.put(`/employees/${id}`, data);
  },

  // Delete employee
  deleteEmployee: (id) => {
    return apiClient.delete(`/employees/${id}`);
  },

  // Toggle employee status
  toggleStatus: (id) => {
    return apiClient.patch(`/employees/${id}/toggle-status`);
  },

  // Get dashboard statistics
  getStats: () => {
    return apiClient.get('/employees/dashboard/stats');
  },

  // Get form data (departments, roles, etc.)
  getFormData: () => {
    return apiClient.get('/employees/form/data');
  },

  // Get sort fields
  getSortFields: () => {
    return apiClient.get('/employees/form/sort-fields');
  },

  // Import employees from Excel
  importEmployees: (formData, onUploadProgress = null) => {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    
    if (onUploadProgress) {
      config.onUploadProgress = onUploadProgress;
    }

    return apiClient.post('/employees/import', formData, config);
  },

  // Export employees data
  exportData: (params = {}) => {
    return apiClient.get('/employees/export/data', {
      params,
      responseType: 'blob',
    });
  },

  // Download import template
  downloadTemplate: () => {
    return apiClient.get('/employees/export/template', {
      responseType: 'blob',
    });
  },

  // Bulk operations
  bulkDelete: (ids) => {
    return apiClient.post('/employees/bulk/delete', { ids });
  },

  bulkUpdateStatus: (ids, status) => {
    return apiClient.post('/employees/bulk/update-status', { ids, status });
  },

  // Search employees
  searchEmployees: (query) => {
    return apiClient.get('/employees', {
      params: {
        search: query,
        per_page: 10,
      }
    });
  },

  // Get employee by employee ID
  getEmployeeByCode: (employeeCode) => {
    return apiClient.get('/employees', {
      params: {
        employee_code: employeeCode,
        per_page: 1,
      }
    });
  },

  // Get employees by department
  getEmployeesByDepartment: (departmentId) => {
    return apiClient.get('/employees', {
      params: {
        department: departmentId,
      }
    });
  },

  // Get employees by designation
  getEmployeesByDesignation: (designation) => {
    return apiClient.get('/employees', {
      params: {
        designation: designation,
      }
    });
  },

  // Get active employees only
  getActiveEmployees: (params = {}) => {
    return apiClient.get('/employees', {
      params: {
        ...params,
        status: 'Active',
      }
    });
  },

  // Get employee count by status
  getEmployeeCountByStatus: () => {
    return apiClient.get('/employees/dashboard/stats');
  },

  // Check if employee exists
  checkEmployeeExists: (field, value) => {
    return apiClient.get('/employees', {
      params: {
        [field]: value,
        per_page: 1,
      }
    });
  },

  // Get available managers (excluding optional employee)
  getAvailableManagers: (params = {}) => {
    return apiClient.get('/employees/managers/available', { params });
  },
};

export default employeeAPI;
